import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';

import * as types from 'misc/types';
import { getText, getTag, trackGA } from 'misc/helpers';
import { popup_icon_type } from 'components/shared/popup/Popup';
import AttachmentListItem from 'components/inbox/AttachmentListItem';
import Loader from 'components/shared/Loader';
import Stamp from 'components/inbox/Stamp';
import InlineContentViewer from 'components/inbox/InlineContentViewer';

class EnvelopeView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show_attachments: false
        };
    }

    render = () => {
        const { sessions, tags, envelope, view, envelope_contents, content_body } = this.props;

        let inlineContent = {
            customerId: sessions.data.customerId,
            content: content_body
        }

        return (
            <Loader objectToLoad={envelope_contents}>
                {envelope &&
                    envelope_contents.isLoaded && (
                        <div className="inbox-view fill-parent">
                            <div className="top-menu">
                                {view === 'inbox' && (
                                    <div className="top-menu-btn" onClick={() => this.archiveMail()}>
                                        <img src="assets/images/inbox/ico_arkiv.svg" alt="" />
                                        {getText('_5_0_TextLettersArkiv', 'Arkivera')}
                                    </div>
                                )}
                                {envelope.deletable && (
                                    <div className="top-menu-btn" onClick={() => this.deleteMail()}>
                                        <img src="assets/images/inbox/ico_trash.svg" alt="" />
                                        {getText('_5_0_1_LettersRemove', 'Ta bort')}
                                    </div>
                                )}
                            </div>
                            <div className="scroll-content fill-parent">
                                <div className="envelope-header">
                                    <Stamp version="vertical" stampId={envelope.stamp} supportInfo={envelope.supportInfo} />
                                    <div className="header-info">
                                        <div className="header-info-top">
                                            <img src="assets/images/inbox/ico_time.svg" alt="" />
                                            <span className="header-info-top-date">
                                                <Moment format="YYYY-MM-DD">{envelope.timestamp}</Moment>
                                            </span>
                                            {envelope.tagged.length && (
                                                <div className="header-info-top-tag">{getTag(tags, envelope.tagged[0].id)}</div>
                                            )}
                                        </div>
                                        <h1>{envelope.sender.name}</h1>
                                        <h2>{envelope.title}</h2>
                                        {envelope.supportInfo && (
                                            <div
                                                onClick={() => this.showInfoPopup(envelope.sender.name, envelope.supportInfo)}
                                                className="header-info-contact"
                                            >
                                                {getText('_5_0_1_Textcontactus', 'Kontakta oss')}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {envelope_contents.data &&
                                    envelope_contents.data.length > 0 && (
                                        <div className="attachments">
                                            <div className="attachments-header">
                                                <img src="assets/images/inbox/ico_attachments.svg" alt="" />
                                                <span>{this.getNrAttachments(envelope_contents.data.length)}</span>
                                                <button className="button-yellow button-small" onClick={() => this.toggleAttachments()}>
                                                    {this.state.show_attachments
                                                        ? getText('_5_0_2TextHide', 'Dölj')
                                                        : getText('_5_0_1_TextLettershow', 'Visa')}
                                                </button>
                                            </div>
                                            <div className={this.state.show_attachments ? 'attachments-list show' : 'attachments-list'}>
                                                <ul>{envelope_contents.data.map(attachment => <AttachmentListItem {...attachment} />)}</ul>
                                            </div>
                                        </div>
                                    )}
                               
                                <InlineContentViewer {...inlineContent} />
                            </div>
                        </div>
                    )}
            </Loader>
        );
    };

    archiveMail() {
        const { envelope, sessions, dispatch } = this.props;
        
        trackGA('5.4 Arkivera');

        dispatch({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.archive,
                header: '',
                text: getText('_5_4_Textmovetoarchive', 'Vill du flytta ditt brev till arkivet?'),
                buttons: [
                    {
                        buttonClasses: 'button-yellow button-ok',
                        label: getText('_5_5_Textyes', 'Ja'),
                        action: {
                            type: types.SAGA_ENVELOPE_ARCHIVE.REQUEST,
                            customerId: sessions.data.customerId,
                            envelopeId: envelope.id,
                            state: envelope.state
                        }
                    },
                    {
                        buttonClasses: 'button-yellow button-ok',
                        label: getText('_5_5_TextNo', 'Nej'),
                        action: { type: types.POPUP_HIDE }
                    }
                ]
            }
        });
    }

    deleteMail() {
        const { envelope, sessions, view, dispatch } = this.props;

        trackGA('5.5 Ta bort');

        dispatch({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.delete,
                header: '',
                text: getText('_5_5_Textremoveletter', 'Är du säker på att du vill ta bort ditt brev?'),
                buttons: [
                    {
                        buttonClasses: 'button-yellow button-ok',
                        label: getText('_5_5_Textyes', 'Ja'),
                        action: {
                            type: types.SAGA_ENVELOPE_DELETE.REQUEST,
                            customerId: sessions.data.customerId,
                            envelopeId: envelope.id,
                            view: view
                        }
                    },
                    {
                        buttonClasses: 'button-yellow button-ok',
                        label: getText('_5_5_TextNo', 'Nej'),
                        action: { type: types.POPUP_HIDE }
                    }
                ]
            }
        });
    }

    showInfoPopup(senderName, supportInfo) {
        const { dispatch } = this.props;

        let payload = {
            show: true,
            icon: popup_icon_type.logo,
            logo_url: supportInfo.logo,
            header: senderName,
            text: supportInfo.text
        };
        
        if (supportInfo.emailAddress) {
            payload.mail = supportInfo.emailAddress;

        }
        if (supportInfo.phoneNumber) {
            payload.phone = supportInfo.phoneNumber;
        }

        dispatch({
            type: types.POPUP_SHOW,
            payload: payload
        });

        trackGA('5.3 Support info');
    }

    getNrAttachments(nrAttachments) {
        let text = '';
        if (nrAttachments > 1) {
            text = getText('_5_0_1TextAttachments', '2 Bilagor');
            text = text.replace('2', nrAttachments);
        } else {
            text = getText('_5_0_1TextAttachment', '1 Bilaga');
        }
        return text;
    }

    toggleAttachments() {
        this.setState(prevState => ({
            show_attachments: !prevState.show_attachments
        }));
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.updateView();
        }
    }

    componentDidMount() {
        this.updateView();

        trackGA('5.0 Brev');
    }

    updateView() {
        this.setState(prevState => ({
            show_attachments: false
        }));

        // Get list of contents for this envelope
        const envelopeId = this.props.match.params.id;
        const { sessions, view, dispatch } = this.props;

        dispatch({
            type: types.SAGA_ENVELOPE_CONTENTS_GET.REQUEST,
            view: view,
            customerId: sessions.data.customerId,
            envelopeId: envelopeId
        });
    }

    //componentWillUpdate(nextProps, nextState) {}

    //componentDidUpdate(prevProps, prevState) {}

    //componentWillReceiveProps(nextProps) {}

    //componentWillUnmount() {}
}

// Get envelope with id from url
const mapStateToProps = (state, ownProps) => {
 
    let envelope;
 
    const { location } = ownProps;
    
    let view = 'inbox';
    if(location.pathname.startsWith("/archives")){
        view = 'archives';
    }

    if(view === 'inbox'){
        if (state.envelopes_inbox.data) {
            envelope = state.envelopes_inbox.data.find(envelope => envelope.id === ownProps.match.params.id);
        }
    }else if(view === 'archives'){
        if (state.envelopes_archives.data) {
            envelope = state.envelopes_archives.data.find(envelope => envelope.id === ownProps.match.params.id);
        }
    }

    return {
        view: view,
        sessions: state.sessions,
        tags: state.tags,
        envelope: envelope,
        envelope_contents: state.envelope_contents,
        content_body: state.envelope_content_inline
    };
};

export default connect(mapStateToProps)(EnvelopeView);


// WEBPACK FOOTER //
// ./src/components/views/inbox/EnvelopeView.js